import axios from '@axios'

export const state = {
  activityLogs: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}

export const getters = {
  allActivityLogs: (state) => state.activityLogs,
  currentPage: (state) => state.currentPage,
  totalPages: (state) => state.totalPages,
  perPage: (state) => state.perPage,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_LOGS: (state, data) => {
    if (!data) {
      state.activity_log = []
      return false
    }
    let { activityLogs, page, perPage, totalRecords, totalPages } = data
    state.totalPages = totalPages
    state.currentPage = page
    state.totalRecords = totalRecords
    state.perPage = perPage
    state.activityLogs = activityLogs
  },
}

export const actions = {
  async getActivityLog({ commit }, params) {
    return axios
      .get('/log/activity-log', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_LOGS', resp.data)
        } else {
          commit('GET_LOGS', [])
        }
      })
      .catch(() => {
        commit('GET_LOGS', [])
      })
  },
}
